import React from 'react';
import { InfoIcon } from 'lucide-react';
import { pricing, pricingNotes } from '../data/pricing';
import { company } from '../data/company';
import { SectionHeading } from './SectionHeading';
export function Pricing() {
  return <section id="tarifs" className="bg-ink-950 py-16 text-bone lg:py-24" data-id="element-157" data-mp="2ohe8qfgpqvfc">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-158" data-mp="2jjcovsbgqs2t">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-159" data-mp="2jlyv9ommb1jg">
          <div data-id="element-160" data-mp="1vubkqh9ny33c">
            <SectionHeading title="Des tarifs annoncés avant, pas découverts après" tone="dark" intro="Le dépannage serrurerie a mauvaise réputation à cause des devis gonflés sur place. Voici mes prix de départ, les mêmes pour tout le monde." data-id="element-161" data-mp="1vvv2kcaywm78" />
            <div className="mt-8 space-y-4" data-id="element-162" data-mp="20vhhcq6g2ai5">
              {pricingNotes.map(note => <p key={note} className="flex gap-3 text-sm leading-relaxed text-ink-500" data-id="element-163" data-mp="3h9hbtlmit7y0">
                  <InfoIcon className="mt-0.5 h-4 w-4 flex-none text-brass" aria-hidden="true" data-id="element-164" data-mp="3c81oto0s8rcz" />
                  {note}
                </p>)}
            </div>
          </div>

          <div data-id="element-165" data-mp="4rktxvitw54e">
            <table className="w-full border-collapse text-left" data-id="element-166" data-mp="4v8l4o0swffy">
              <caption className="sr-only" data-id="element-167" data-mp="9tjukxn6onxn">Tarifs de départ des interventions</caption>
              <thead data-id="element-168" data-mp="eqaa9jv2thij">
                <tr className="border-b border-ink-700" data-id="element-169" data-mp="eqtk0dakozlh">
                  <th scope="col" className="pb-3 text-xs font-semibold uppercase tracking-[0.14em] text-ink-500" data-id="element-170" data-mp="3d9h73d8ti7z5">
                    Intervention
                  </th>
                  <th scope="col" className="pb-3 text-right text-xs font-semibold uppercase tracking-[0.14em] text-ink-500" data-id="element-171" data-mp="3i5pg08wf94xv">
                    Tarif
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-172" data-mp="2uipp5narl995">
                {pricing.map(row => <tr key={row.label} className="border-b border-ink-800 align-top" data-id="element-173" data-mp="2ugdbhmc1hl1w">
                    <th scope="row" className="py-5 pr-4 font-normal" data-id="element-174" data-mp="2zfzp3wvs53b8">
                      <span className="block font-display text-base font-bold text-bone" data-id="element-175" data-mp="2rftcqb7edjfn">
                        {row.label}
                      </span>
                      <span className="mt-1 block text-sm text-ink-500" data-id="element-176" data-mp="2mfxi32klb4cr">{row.note}</span>
                    </th>
                    <td className="py-5 text-right font-display text-base font-bold text-brass-light" data-id="element-177" data-mp="2w7ux6kepyggr">
                      {row.price}
                    </td>
                  </tr>)}
              </tbody>
            </table>
            <a href={company.phoneHref} className="mt-8 inline-flex items-center justify-center rounded-sm bg-brass px-6 py-3.5 font-display text-base font-bold text-ink-950 transition-colors duration-150 ease-out hover:bg-brass-light" data-id="element-178" data-mp="23k7fpe8qw5yc">
              Obtenir mon prix exact au téléphone
            </a>
          </div>
        </div>
      </div>
    </section>;
}